<template>
  <div class="contentHome">
    <div class="centerPage">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
        <el-breadcrumb-item><a href="javascript:void(0);" @click="doctorDetail()" class="aHref">医生详情</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>预约订单</el-breadcrumb-item>
      </el-breadcrumb>
      <el-steps :active="active" align-center class="stepRes">
        <el-step v-for="(item,index) in titleList" :title="item.title" :key="index"></el-step>
      </el-steps>
      <div class="doctor">
        <template v-if="active == 1">
          <div class="payment">
            <div class="flex verify">
              <span class="tit">确认预约信息</span>
              <p>可处理预约单剩余时间：<span>{{ timer1 }}</span></p>
            </div>
            <el-table :data="tableData" class="tableData"
                      :header-cell-style="{'background':'rgba(86,123,255,0.2)','color': '#303139','fontWeight':'400','textAlign':'center'}">
              <el-table-column align="center" label="咨询医师" width="180">
                <template slot-scope="scope">
                  <img :src="scope.row.headImgPath" alt="" width="75px">
                  <p>{{ scope.row.doctorName }}</p>
                </template>
              </el-table-column>
              <el-table-column prop="appointNo" align="center" label="预约号" width="180"></el-table-column>
              <el-table-column align="center" label="预约时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.appointDateShow }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="consultMode" align="center" label="咨询方式" width="180">
                <template slot-scope="scope">
                  <span v-if="scope.row.consultMode == 1">语音</span>
                  <span v-else-if="scope.row.consultMode == 2">视频</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="咨询费用" width="180">
                <template slot-scope="scope">
                  <span class="pay">￥{{ scope.row.payAmount }}</span>
                  <span class="not pay"
                        v-if="scope.row.payAmount!=scope.row.initialPayAmount">￥{{ scope.row.initialPayAmount }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="state" align="center" label="预约状态">待付款</el-table-column>
            </el-table>

            <div class="payWay">
              <span class="tit">支付方式</span>
              <el-radio-group v-model="payWay" class="radioGroup">
                <el-radio label="1" border disabled>
                  <span>支付宝</span><img src="../../assets/img/zfb.png" alt="" width="27">
                </el-radio>
                <el-radio label="2" border>
                  <span>微信</span><img src="../../assets/img/wx.png" alt="" width="27">
                </el-radio>
                <el-radio label="3" border disabled>
                  <span>PayPal</span><img src="../../assets/img/pai.png" alt="" width="27">
                </el-radio>
              </el-radio-group>
            </div>

            <div class="payWay">
              <span class="tit">优惠券</span>
              <div class="coupon-list">
                <div class="coupon flex" v-for="item in coupons" :key="item.id">
                  <div class="type">{{ item.couponType|couponTypeFmt }}</div>
                  <div class="info flex">
                    <strong class="discount" v-if="item.couponType==1">{{ item|couponDiscountFmt }}</strong>
                    <strong class="discount" v-else style="font-size: 20px">抵扣次数</strong>
                    <el-tooltip effect="dark" :content="item.couponTitle" placement="left-start">
                      <div class="name overFlow" style="text-align: center;">{{ item.couponTitle }}</div>
                    </el-tooltip>
                    <div class="time">{{ new Date(item.limitStartDate).Format('yy.MM.dd') }} -
                      {{ new Date(item.limitEndDate).Format('yy.MM.dd') }}
                    </div>
                  </div>
                  <span class="selector" :use="item.checked"></span>
                </div>
                <div style="clear:both;"></div>
              </div>
            </div>

            <div class="payWay" v-show="payWay==2 && qrImg.finish">
              <div class="qrImg" :state="payStatus">
                <img src="../../assets/img/WePayLogo.png" width="120" style="margin-right: 10px;"/>
                <img :src="qrImg.url" width="200" height="200" style="vertical-align: top;"/>
              </div>
              <div style="padding-left: 130px">
                <img src="../../assets/img/wx_pay_desc.png" width="200"/>
              </div>
            </div>
            <div class="payWay">
              <span class="tit">预约须知</span>
              <p>预约成功后，客服人员将会给您电话回访确认预约详细内容 </p>
              <p v-if="contact.tel">电话：{{ contact.tel }}</p>
              <p v-if="contact.wx"> 微信：{{ contact.wx }}</p>
            </div>
          </div>
          <div class="paySubmit flex">
            <p>应付款：<span>￥{{ tableData[0].payAmount }}</span></p>

            <el-button @click="pay()" :disabled="canNotPay">立即支付</el-button>
          </div>
          <div style="clear: both"></div>
        </template>
        <template v-if="active===2">
          <div class="advisory">
            <img src="../../assets/img/tips.png" alt="" width="140">
            <p>还未到约定时间，请等待</p>
            <el-button @click="$router.push('/user/counsel')">我知道了</el-button>
          </div>
        </template>
      </div>
    </div>
    <el-dialog
        :show-close="false"
        class="tips paySuccess"
        top="0"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="400px">
      <img src="../../assets/img/success.png" alt="" width="140">
      <p>支付成功！请准时进行咨询</p>
      <div class="sub">
        <el-button @click="$router.push('/user/counsel')">我知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import base from '@/api/common';
import sysConstant from '@/api/system_constant';

export default {
  name: "orderPay",
  data() {
    return {
      active: 1,
      titleList: [{
        title: '填写订单',
      }, {
        title: '付款',
      }, {
        title: '咨询',
      }],
      checked: false,
      tableData: [{}],
      payWay: '2',
      dialogVisible: false,
      state: this.$route.query.state,
      queryTimer: 0,
      timerInterval: null,
      timer1: '29:59',
      canNotPay: false,
      qrImg: {
        finish: false,
        url: '', // 二维码生成状态
      },
      payStatus: 0, // 0-未开始 1-支付中 2-完成  3-失效
      contact: {
        tel: sysConstant.APPOINT_CONTACT.TEL,
        wx: sysConstant.APPOINT_CONTACT.WECHAT,
      },
      doctorAccount: '',
      unCoupon: true,
      coupons: []
    }
  },
  beforeMount() {
    let id = this.$route.params.id;
    // 获取预约信息
    this.getData()
  },
  mounted() {
  },
  destroyed() {
    window.clearInterval(this.queryTimer);
  },
  inject: ['reload'],
  methods: {
    pay() {
      let vm = this;
      if (this.canNotPay) {// 超时，不能支付
        return;
      }
      if (vm.payStatus == 1) {
        vm.$message.warning("请扫码已完成支付!");
        return;
      }
      // 请求支付二维码
      vm.$ajax.post(base.api.appoint.pay.replace('{id}', (this.$route.params.id))).then((res) => {
        if (res.data.status == 'success') {
          vm.qrImg.finish = true;
          vm.qrImg.url = res.data.url;
          vm.payStatus = 1;
          // vm.dialogVisible = true
          // 轮询订单情况
          let appointNo = res.data.no;
          vm.queryTimer = setInterval(() => {
            if (vm.payStatus == 3) {
              clearInterval(vm.queryTimer);
            }
            vm.$ajax.post(base.api.appoint.orderStatus.replace("{no}", appointNo)).then(res => {
              if (res.data.status === 'success') {
                if (res.data.data == 1) { //已支付
                  vm.dialogVisible = true;
                  clearInterval(vm.queryTimer);
                  clearInterval(vm.timerInterval);
                }
              } else {
                vm.$message.error(res.data.message);
                clearInterval(vm.queryTimer);
                setTimeout('location.reload()', 3000); // 刷新页面
              }
            })
          }, 3000);
        } else {
          vm.$message.error(res.data.message);
        }
      })
    },
    getData() {
      let id = this.$route.params.id;
      let vm = this;
      vm.$ajax.get(base.api.user.appointOrder.replace('{id}', id))
          .then((res) => {
            if (res.data.status == 'success') {
              res.data.data.appointDateShow = base.utils.buildShowDate(res.data.data.appointStartLongtime, res.data.data.appointEndLongtime);
              if (res.data.data.payState == 0) {
                res.data.data.state = 1;
              } else if (res.data.data.payState == 1 && res.data.data.appointState == 1) {
                res.data.data.state = 2;
              } else if (res.data.data.payState == 1 && res.data.data.appointState == 4) {
                res.data.data.state = 3;
              }
              vm.tableData = [res.data.data];
              vm.timer(res.data.data.duration);
              // 医生account
              if (res.data.data) {
                vm.doctorAccount = res.data.data.doctorAccount;
              }
              // 获取优惠券信息
              vm.$ajax.get(base.basePath + 'coupon/coupon-user/authorize/order/' + res.data.data.appointNo).then(res => {
                if (res.data.status === 'success') {
                  vm.coupons = res.data.list;
                }
              }).catch(err => {
                vm.$message.error('优惠券信息加载失败');
                console.error(err);
              })
            } else {
              vm.$message.error(res.data.message);
            }
          })
    },
    doctorDetail() {
      // 如果有医生account，跳到详情页，否则跳到咨询页
      if (this.doctorAccount) {
        // this.$router.push({path: '/doctorDetail/' + this.doctorAccount})
        this.$router.push({path: '/' + this.doctorAccount})
      } else {
        this.$router.push({path: '/consult'});
      }
    },
    timer(intDiff) {
      let vm = this;
      vm.timerInterval = setInterval(function () {
        let day = 0,
            hour = 0,
            minute = 0,
            second = 0;//时间默认值
        if (intDiff > 0) {
          day = Math.floor(intDiff / (60 * 60 * 24));
          hour = Math.floor(intDiff / (60 * 60)) - (day * 24);
          minute = Math.floor(intDiff / 60) - (day * 24 * 60) - (hour * 60);
          second = Math.floor(intDiff) - (day * 24 * 60 * 60) - (hour * 60 * 60) - (minute * 60);
        } else {
          clearInterval(vm.timerInterval);
          //
          vm.canNotPay = true;
          vm.payStatus = 3;
        }
        if (minute <= 9) minute = '0' + minute;
        if (second <= 9) second = '0' + second;
        intDiff--;
        vm.timer1 = minute + ':' + second;
      }, 1000);

    },
  },
  filters: {
    couponTypeFmt(type) {
      if (type == 2) {
        return '月卡';
      } else if (type == 3) {
        return '年卡'
      }
      return '优惠券';
    },
    couponDiscountFmt(item) {
      if (item.discountMode == 1) { //折扣
        return item.discountRate / 10 + '折';
      } else if (item.discountMode == 2) { //定额
        return '￥' + item.discountAmount / 100;
      }
      if(item.couponType != 1){ // 月/年卡
        return '抵扣次数';
      }
      return '0';
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/css/consult_b.scss';

</style>

